/**
 * Imports API
 */
import axios from 'axios';
import { API_URL } from '@/App.settings';

/**
 * Stratégie
 */
import { SearchStrategy } from './SearchStrategy';

/**
 * Classe
 */
import BaseShortLBO from '@/types/BaseShortLBO';
import Dictionary from '@/types/Dictionary';

export class ShortLBOSearchStrategy extends SearchStrategy {

    protected override displayer = "ShortLBOSearchDisplayer";
    protected override event = "ShortLBOSelectedEvent";

    /**
     * Exécute l'appel API à 'FilterTree/SearchNode'.
     * @param parameters Les arguments nécessaires pour l'appel API (déjà formatés par le composant 'Search').
     * @returns Une promesse qui résout en un tableau de BaseNode.
     */
    protected async execute(parameters: Dictionary<any>): Promise<BaseShortLBO[]> {
        return new Promise((resolve, reject) => {
            console.debug("Search - ShortLBOSearchStrategy - parameters", parameters);
            axios.post(API_URL + 'FilterTree/SearchShortLBO', parameters).then((response) => {
                if (response && response.data) {
                    console.debug("Search - ShortLBOSearchStrategy - axiosResult", response.data);
                    
                    const result = response.data.map(item => {
                        return new BaseShortLBO(item.Id, item.Name, item.Invariant, item.ObjectType, item.Location, item.IsDepreciated, item.Reference, item.Purpose, item.Address, item.Town, item.PostalCode, item.Country);
                    });

                    resolve(result);
                }
            });
        });
    }
}
